export enum TranslationNamespaces {
  TRANSLATION = 'translation',
  SITE_STATUS = 'site-status'
}
